import { useContext, useMemo, useState } from 'react';
import { DataQuality, HandleAmountClickParams } from './data-quality-chart.types';
import { FleetManagerDashboardContext } from '../dashboard.context';
import { PAGES } from 'common/enums';
import { CRM_VALUE } from 'pages/my-vehicles/my-vehicles';
import {
  VehicleStateCodeLabel,
  VehicleStateCodeValue,
  VehicleStatusesLabel,
  VehicleStatusesValue
} from 'pages/my-vehicles/my-vehicles.props';

import { DATA_QUALITY_CONFIG } from './constants';

export const useDataQualityChart = (dataQuality: DataQuality) => {
  const { openPage } = useContext(FleetManagerDashboardContext);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  const handleChangeSelectedIndex = (index: number) => {
    setSelectedIndex(index);
  };

  const handleChangeHoverIndex = (index: number | null) => {
    setHoverIndex(index);
  };

  const qualities = useMemo(
    () =>
      Object.entries(DATA_QUALITY_CONFIG)
        .map(([key, value]) => ({
          ...value,
          value: dataQuality[key as keyof DataQuality]
        }))
        .filter(({ value }) => value > 0),
    [dataQuality]
  );

  const amounHandleClick = ({ serverValue, clientValue }: HandleAmountClickParams) => {
    openPage({
      page: PAGES.MY_VEHICLES,
      companyCrmName: CRM_VALUE.company,
      filterForServer: {
        [CRM_VALUE.qualityData]: serverValue,
        [CRM_VALUE.stateCode]: [VehicleStateCodeValue.Active],
        [CRM_VALUE.status]: [
          VehicleStatusesValue.InOperation,
          VehicleStatusesValue.ControlRequested,
          VehicleStatusesValue.InControl
        ]
      },
      filterForClient: {
        [CRM_VALUE.qualityData]: clientValue,
        [CRM_VALUE.stateCode]: [VehicleStateCodeLabel.Active],
        [CRM_VALUE.status]: [
          VehicleStatusesLabel.InOperation,
          VehicleStatusesLabel.ControlRequested,
          VehicleStatusesLabel.InControl
        ]
      },
      isMultipleFilter: true
    })();
  };

  return { qualities, amounHandleClick, selectedIndex, hoverIndex, handleChangeSelectedIndex, handleChangeHoverIndex };
};
